import * as React from 'react';
import { Container, Hold, PickupInfo } from 'types/Watchlist';
import { formatHoldStatus } from 'utils/container-transforms';
import { Row, RowGroup } from '../components';

interface Props {
  container: Container;
}

/** Holds to turn into individual rows */
const holdFields: { field: keyof PickupInfo; name: string }[] = [
  { field: 'customsHold', name: 'Customs' },
  { field: 'freightHold', name: 'Freight' },
  { field: 'lineHold', name: 'Line' },
  { field: 'ctfHold', name: 'CTF' },
  { field: 'tmfHold', name: 'TMF' },
  // { field: 'usdaHold', name: 'USDA hold' },
  { field: 'terminalHold', name: 'Terminal' },
];

export const Holds: React.FC<Props> = (props) => {
  const { container } = props;

  const holds = holdFields.map((v) => {
    const { pickupInfo } = container;

    const hold: Hold | null = (pickupInfo?.[v.field] as Hold) || null;

    const formatted = formatHoldStatus(hold?.status, hold?.raw);

    return (
      <Row
        label={v.name}
        className={formatted?.meta?.indicate ? 'text-red-900' : undefined}
        key={v.field}
      >
        {formatted?.value}
      </Row>
    );
  });

  return <RowGroup label="Holds">{holds}</RowGroup>;
};
Holds.displayName = 'Shipments.DetailDrawer.Sections.Availability.Holds';
